import { render, staticRenderFns } from "./StudentstatisticsLessJg.vue?vue&type=template&id=bc1cc870"
import script from "./StudentstatisticsLessJg.vue?vue&type=script&lang=js"
export * from "./StudentstatisticsLessJg.vue?vue&type=script&lang=js"
import style0 from "./StudentstatisticsLessJg.vue?vue&type=style&index=0&id=bc1cc870&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports